<span>
  {{cellValue$ | async | translate}}
</span>
